import { FC } from "react";

import { useFullUserProfileContext } from "Bands/contexts";
import { copy } from "shared/assets";
import { Loader, DrivingPermitTeaser, Title } from "shared/components";
import { Spacer } from "shared/layout";
import { useFetchingUserDocuments } from "Bands/utils";
import { GridContainer } from "shared/styles";

const permitCopy = copy.userDrivingPermit;

export const DrivingPermits: FC = () => {
  const { drivingPermits } = useFullUserProfileContext();

  const { fetchingDrivingPermits } = useFetchingUserDocuments();

  if (fetchingDrivingPermits) return <Loader />;
  if (!drivingPermits?.length) return null;

  return (
    <Spacer size="m">
      <Title title={permitCopy.title} asComponent="h3" size="s" />
      <GridContainer>
        {drivingPermits?.map(permit => (
          <DrivingPermitTeaser key={permit.id} {...permit} />
        ))}
      </GridContainer>
    </Spacer>
  );
};
